import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { ICompany } from '../../../../../../interfaces/companies';
import { getResponseMessage } from '../../../../../../utils/utils';
import { getOffersCompanies } from '../../../../../../crud/offer.crud';

export const useGetCompaniesOffers = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loadingCompanies, setLoading] = useState(false);
  const [companies, setCompanies] = useState<ICompany[]>([]);

  const fetchCompanies = useCallback(async (status: 'moderation' | 'active' | 'deleted') => {
    setLoading(true);
    getOffersCompanies({ status })
      .then((res: any) => {
        setCompanies(res.data.data);
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return { fetchCompanies, loadingCompanies, companies };
};
